const MuiMenuItem = {
  root: {
    fontSize: '1.6rem',
  },
};

export default MuiMenuItem;
